/**
 * The chat history the browser sends with each turn: the prior turns that did
 * not fail, then the current query.
 *
 * Lane 1410 W5: the flagged contract history (CHAT_FAILED_HISTORY_FILTER_ENABLED),
 * the signed turn contract and the picker-scaffold filters left with the legacy
 * chat path. The Mirror runtime reads a conversation's history from the
 * server-side claim store; this payload stays for request-shape compatibility.
 */
export function buildChatHistory(messages, currentQuery) {
  return [
    ...(messages || []).filter((message) => !message.error),
    { role: 'user', content: currentQuery },
  ].map(({ role, content }) => ({ role, content }));
}
